import User from './User';

export interface IPreviewComment {
  id: string;
  author: User;
  body: string;
  createdAt: string;
  updatedAt: string;
}

class PreviewComment {
  public readonly id: string;
  public readonly author: User;
  public readonly body: string;
  public readonly createdAt: string;
  public readonly updatedAt: string;

  constructor({
    id,
    author,
    body,
    createdAt,
    updatedAt,
  }: {
    id: string;
    author: User;
    body: string;
    createdAt: string;
    updatedAt: string;
  }) {
    this.id = id;
    this.author = author;
    this.body = body;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  public toJSON = () => ({
    id: this.id,
    authore: this.author,
    body: this.body,
    createdAt: this.createdAt,
    updatedAt: this.updatedAt,
  });

  public static fromJSON = (json: IPreviewComment): PreviewComment => {
    const { id, author, body, createdAt, updatedAt } = Object.assign({}, json);

    if (typeof id !== 'string') throw new Error('.id must be a string');
    if (typeof body !== 'string') throw new Error('.body must be a string');
    if (typeof createdAt !== 'string') throw new Error('.body must be a string');
    if (typeof updatedAt !== 'string') throw new Error('.body must be a string');

    const _author = User.fromJSON(author);

    return new PreviewComment({
      id,
      author: _author,
      body,
      createdAt,
      updatedAt,
    });
  };
}

export default PreviewComment;
